import { StrictMode, Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import GlobalStyles from './App/globalStyles';
import ErrorPage from './Pages/ErrorPage';
import Spinner from './Style-guide/Spinner';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <GlobalStyles />
      <ErrorBoundary FallbackComponent={ErrorPage}>
        <Suspense fallback={<Spinner />}>
          <App />
        </Suspense>
      </ErrorBoundary>
    </BrowserRouter>
  </StrictMode>
);
